export default __webpack_public_path__ + "static/media/cursor.ee60ce40.svg";